import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {Pressable} from 'react-native';
import {useTheme} from 'styled-components';
import {BigBoldBlueText} from '../CommonComponents.jsx';
import vars from './../root';
import InfoIcon from './icons/InfoIcon.jsx';

const FontIconStyle = {
  color: vars.WHITE,
  width: '100%',
  height: '100%',
};
const FontIconStyleWeb = {
  ...FontIconStyle,
  padding: 4,
  alignSelf: 'center',
};

export function FontIcon({
  back,
  theme,
  kind,
  parentStyle,
  icon,
  customIcon,
  style,
  text,
  textColor,
  onPress,
}) {
  const appTheme = useTheme();
  const backgroundColor =
    !back || back === 'orange'
      ? appTheme.name === 'dark'
        ? appTheme.colors.background.btn
        : vars.ORANGE_RED
      : back === 'blue'
      ? appTheme.colors.background.btn
      : back === 'green'
      ? vars.GREEN
      : back === 'purple'
      ? 'purple'
      : back === 'transparent'
      ? vars.transparent
      : back === 'dark'
      ? vars.DARK_WHITE
      : appTheme.name === 'dark'
      ? appTheme.colors.background.btn
      : vars.YELLOW;

  const className = `myBtn${theme === 'transparent' ? '-Transparent' : ''} ${
    appTheme.name === 'dark' ? 'myBtn-dark' : ''
  }`;
  const style1 = {
    backgroundColor: backgroundColor,
    cursor: 'pointer',
    width:
      !kind || kind === 'full'
        ? '100%'
        : kind === 'normal'
        ? 30
        : kind === 'large'
        ? 40
        : kind === 'tiny'
        ? 10
        : 20,
    height:
      !kind || kind === 'full'
        ? '100%'
        : kind === 'normal'
        ? 30
        : kind === 'large'
        ? 40
        : kind === 'tiny'
        ? 10
        : 20,
    borderRadius: !theme || theme === 'circle' ? 20 : 3,
    alignSelf: 'center',
    justifyContent: 'center',
  };
  const allStyles = !parentStyle
    ? style1
    : {
        ...style1,
        ...parentStyle,
      };

  return (
    <div className={className}>
      <Pressable style={allStyles} onPress={onPress}>
        {customIcon && customIcon === 'info' && <InfoIcon />}
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            style={[
              FontIconStyleWeb,
              style ? style : {},
              kind === undefined || kind === 'full'
                ? {
                    width: 22,
                    height: 22,
                  }
                : {
                    width: '100%',
                    height: '100%',
                  },
            ]}
          />
        )}
        {text && (
          <BigBoldBlueText
            style={{
              padding: 0,
              paddingRight: 10,
              fontSize: 11,
              color: textColor,
            }}
            text={text}
          />
        )}
      </Pressable>
    </div>
  );
}
export function SimpleFontIcon({
  onPress,
  kind,
  icon,
  style,
  parentStyle,
  color = vars.LIGHT_SILVER,
  onHoverIn = undefined,
  onHoverOut = undefined,
}) {
  let allStyles = {
    cursor: !onPress ? 'auto' : 'pointer',
    width:
      !kind || kind === 'full'
        ? '100%'
        : kind === 'x-large'
        ? 48
        : kind === 'large'
        ? 38
        : kind === 'x-normal'
        ? 32
        : kind === 'normal'
        ? 28
        : kind === 'midSize'
        ? 22
        : kind === 'x-small'
        ? 16
        : kind === 'small'
        ? 11
        : 22,
    height:
      !kind || kind === 'full'
        ? '100%'
        : kind === 'x-large'
        ? 48
        : kind === 'large'
        ? 38
        : kind === 'x-normal'
        ? 32
        : kind === 'normal'
        ? 28
        : kind === 'midSize'
        ? 22
        : kind === 'x-small'
        ? 16
        : kind === 'small'
        ? 11
        : 22,
    alignSelf: 'center',
    color: color,
    justifyContent: 'center',
  };
  if (parentStyle !== undefined)
    allStyles = {
      ...allStyles,
      ...parentStyle,
    };
  return (
    <Pressable
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
      style={allStyles}
      onPress={onPress}>
      <FontAwesomeIcon
        icon={icon}
        style={[
          FontIconStyleWeb,
          {
            color: color,
            cursor: onPress === undefined ? 'auto' : 'pointer',
          },
          style ? style : {},
        ]}
      />
    </Pressable>
  );
}
